module.exports = __webpack_public_path__ + "img/logo.f1946c41.svg";